import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { HttpService } from './http.service';
import { ServiceImageModel } from '@models/service-image/service-image.model';

type ServiceImagesDictionary = Record<string, { url: string; bg: string }>;
type ServiceImagesResponse = ServiceImageModel[] | ServiceImagesDictionary;

@Injectable({
  providedIn: 'root',
})
export class ServiceImageService {
  private readonly serviceImagesApi = !environment.isFullOnline
    ? `${environment.caisseApiUrl}/services/images`
    : `${environment.caisseApiUrl}/orders/getImagesForServices`;
  private readonly httpService = inject(HttpService);

  getServiceImages(services: number[]): Observable<ServiceImageModel[]> {
    return this.httpService
      .post<ServiceImagesResponse>(`${this.serviceImagesApi}`, {
        services: services,
      })
      .pipe(
        map((response) =>
          this.#toServiceImageList(response).map((image) => ({
            ...image,
            url: this.#toLocalUrl(image.url),
          })),
        ),
      );
  }

  #toServiceImageList(response: ServiceImagesResponse): ServiceImageModel[] {
    if (Array.isArray(response)) {
      return response;
    }
    return Object.entries(response).map(([id, image]) => ({
      id: Number(id),
      url: image.url,
      bg: image.bg,
    }));
  }

  #toLocalUrl(url: string): string {
    const remote = new URL(url);
    const local = new URL(environment.caisseApiUrl);
    return `${local.protocol}//${local.host}${remote.pathname}${remote.search}`;
  }
}
